// https://github.com/developit/mitt/blob/main/README.md#usage
import mitt from 'mitt';
import type { Emitter } from 'mitt';
import type { PaginationEvents } from '$shared/inline-pagination/inlinePaginationEvents'
import type { TabEvents } from '$shared/tabs/tabEvents';
import type { LessonSidebarEvents } from '$comp/lessons/sidebar/LessonSidebarEvents';
import type { LessonTopbarEvents } from '$comp/lessons/topbar/LessonTopbarEvents';
import type { PracticeSidebarEvents } from '$comp/lessons/sidebar/PracticeSidebarEvents';
import type { AutoplayEvents } from '$comp/video/AutoplayEvents';
import type { PlusPlayerEvents } from '$comp/video/PlusPlayerEvents';
import type { ExternalLinkEvents } from '$comp/curations/ExternalLinkEvents';
import type { CurationReminderEvents } from '$comp/curations/CurationReminderEvents';
import type { QuestionSetEvents } from '$comp/curations/QuestionSetEvents';
import type { FlashEvents } from '$shared/flash/FlashEvents';

export type Events = PaginationEvents & TabEvents & LessonSidebarEvents & LessonTopbarEvents & PracticeSidebarEvents & AutoplayEvents & PlusPlayerEvents & ExternalLinkEvents & CurationReminderEvents & QuestionSetEvents & FlashEvents;

export const eventBus: Emitter<Events> = mitt<Events>();
